import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import emailjs from '@emailjs/browser'

import css from './Contacts.module.scss'
import { uiConstants } from '../../../../constants'
import PageContent from '../../../UI/PageContent/PageContent'

const Contacts = () => {
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)

  const {
    register,
    handleSubmit,
    reset,
    formState: { isValid }
  } = useForm()

  const onSubmit = (data) => {
    setSending(true)
    emailjs
      .send(
        uiConstants.emailjs.serviceId,
        uiConstants.emailjs.templateId,
        data,
        uiConstants.emailjs.publicKey
      )
      .then(() => {
        setMessage(
          'Messaggio inviato con successo, ti ricontatteremo al più presto.'
        )
      })
      .catch(() => {
        setMessage("Errore nell'invio del messaggio")
      })
      .finally(() => {
        setSending(false)
        reset()
        setTimeout(() => {
          setMessage('')
        }, 5000)
      })
  }

  const renderField = (f) => {
    switch (f.type) {
      case 'textarea':
        return (
          <textarea
            name={f.name}
            {...register(f.name, {
              required: f.required || false,
              validate: f.validate
            })}
          />
        )
      default:
        return (
          <input
            name={f.name}
            type={f.type}
            {...register(f.name, {
              required: f.required || false,
              validate: f.validate
            })}
          />
        )
    }
  }

  return (
    <div className={css.Container}>
      <PageContent>
        <h1>Contattaci</h1>
        Vuoi avere maggiorni informazioni sui nostri servizi? Desideri
        organizzare un evento o un corso nella tua città o azienda? Compila il
        form sottostante o contattaci direttamente.
        <br />
        <br />
        <a href='tel:+393337248456' className={css.Phone}>
          <i className='fa-solid fa-phone'></i>
          Mauro
        </a>
        &nbsp;&nbsp;&nbsp;
        <a href='tel:+393494623924' className={css.Phone}>
          <i className='fa-solid fa-phone'></i>
          Luca
        </a>
        <h2 className='mt'>Oppure Scrivici</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          {uiConstants.contacts.map((f) => {
            return (
              <label key={f.name}>
                {f.label} {f.required && '*'}
                {renderField(f)}
              </label>
            )
          })}
          <div className={css.Privacy}>
            Inviando questo messaggio accetti la nostra{' '}
            <Link to='/privacy-policy'>Privacy Policy</Link>
          </div>
          <button
            disabled={!isValid || sending}
            type='submit'
            aria-label='Save'
            className={css.Submit}
          >
            {sending ? 'Invio in corso...' : 'Invia messaggio'}
          </button>
          <div className={css.Message}>{message}</div>
        </form>
      </PageContent>
    </div>
  )
}

export default Contacts
